<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.barcode">
    <app-popup-header title="{{localService.languageContent.barcode.bulk_print}}"></app-popup-header>
    <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="valuesDisplayValues">
        <div class="row" *ngFor="let item of valuesDisplayValues">
            <div class="col-12" style="text-align: center;">
                <qrcode *ngIf="item.isSelected" id="qrcode_container_{{item.key}}" [qrdata]="onGetValue(item)"
                    [width]="barCodeSize" [errorCorrectionLevel]="'H'" [elementType]="'img'"></qrcode>
                <div *ngIf="item.isSelected && item.value != ''" class="en">
                    {{item.value}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-print *ngIf="IsPrint" [printWidth]="printWidth" [fileName]="FileName" [content]="printContent">
                </app-print>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-8">
                <div class="row">
                    <div class="col-6">
                        <app-label [Text]="localService.languageContent.barcode.bar_code_size"></app-label>
                    </div>
                    <div class="col-6">
                        <input autocomplete="off" type="number" class="number" [ngClass]="barCodeSize ? 'en' : ''"
                            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)"
                            [(ngModel)]="barCodeSize"
                            placeholder="*{{localService.languageContent.barcode.bar_code_size}}"
                            title="*{{localService.languageContent.barcode.bar_code_size}}"
                            (blur)="onSaveLastUsedSettings()" />
                    </div>
                </div>
            </div>
            <div class="col-4" style="text-align: right;">
                <button type="button" class="btn btn-primary"
                    (click)="onPrint()">{{localService.languageContent.barcode.print}}&nbsp;({{valuesDisplayValues.length}})</button>
            </div>
        </div>
    </div>
</div>